import { Folder, File } from '@nextcloud/files';
import { generateOcsUrl, generateRemoteUrl } from '@nextcloud/router';
import { getCurrentUser } from '@nextcloud/auth';
import axios from '@nextcloud/axios';
import logger from './logger';
export const rootPath = `/files/${getCurrentUser()?.uid}`;
const headers = {
    'Content-Type': 'application/json',
};
const ocsEntryToNode = function (ocsEntry) {
    try {
        const isFolder = ocsEntry?.item_type === 'folder';
        const hasPreview = ocsEntry?.has_preview === true;
        const Node = isFolder ? Folder : File;
        const fileid = ocsEntry.file_source;
        // Generate path and strip double slashes
        const path = ocsEntry?.path || ocsEntry.file_target;
        const source = generateRemoteUrl(`dav/${rootPath}/${path}`.replaceAll(/\/\//gm, '/'));
        // Prefer share time if more recent than item mtime
        let mtime = ocsEntry?.item_mtime ? new Date((ocsEntry.item_mtime) * 1000) : undefined;
        if (ocsEntry?.stime > (ocsEntry?.item_mtime || 0)) {
            mtime = new Date((ocsEntry.stime) * 1000);
        }
        return new Node({
            id: fileid,
            source,
            owner: ocsEntry?.uid_owner,
            mime: ocsEntry?.mimetype,
            mtime,
            size: ocsEntry?.item_size,
            permissions: ocsEntry?.item_permissions || ocsEntry?.permissions,
            root: rootPath,
            attributes: {
                ...ocsEntry,
                'has-preview': hasPreview,
                favorite: ocsEntry?.tags?.includes(window.OC.TAG_FAVORITE) ? 1 : 0,
            },
        });
    }
    catch (error) {
        logger.error('Error while parsing OCS entry', { error });
        return null;
    }
};
const getShares = function (shared_with_me = false) {
    const url = generateOcsUrl('apps/files_sharing/api/v1/shares');
    return axios.get(url, {
        headers,
        params: {
            shared_with_me,
            include_tags: true,
        },
    });
};
const getSharedWithYou = function () {
    return getShares(true);
};
const getSharedWithOthers = function () {
    return getShares();
};
const getRemoteShares = function () {
    const url = generateOcsUrl('apps/files_sharing/api/v1/remote_shares');
    return axios.get(url, {
        headers,
        params: {
            include_tags: true,
        },
    });
};
const getPendingShares = function () {
    const url = generateOcsUrl('apps/files_sharing/api/v1/shares/pending');
    return axios.get(url, {
        headers,
        params: {
            include_tags: true,
        },
    });
};
const getRemotePendingShares = function () {
    const url = generateOcsUrl('apps/files_sharing/api/v1/remote_shares/pending');
    return axios.get(url, {
        headers,
        params: {
            include_tags: true,
        },
    });
};
const getDeletedShares = function () {
    const url = generateOcsUrl('apps/files_sharing/api/v1/deletedshares');
    return axios.get(url, {
        headers,
        params: {
            include_tags: true,
        },
    });
};
export const getContents = async (sharedWithYou = true, sharedWithOthers = true, pendingShares = false, deletedshares = false, filterTypes = []) => {
    const promises = [];
    if (sharedWithYou) {
        promises.push(getSharedWithYou(), getRemoteShares());
    }
    if (sharedWithOthers) {
        promises.push(getSharedWithOthers());
    }
    if (pendingShares) {
        promises.push(getPendingShares(), getRemotePendingShares());
    }
    if (deletedshares) {
        promises.push(getDeletedShares());
    }
    const responses = await Promise.all(promises);
    const data = responses.map((response) => response.data.ocs.data).flat();
    let contents = data.map(ocsEntryToNode).filter((node) => node !== null);
    if (filterTypes.length > 0) {
        contents = contents.filter((node) => filterTypes.includes(node.attributes?.share_type));
    }
    return {
        folder: new Folder({
            id: 0,
            source: generateRemoteUrl('dav' + rootPath),
            owner: getCurrentUser()?.uid || null,
        }),
        contents,
    };
};
